import create from 'zustand'

type ModalStore = {
  isOpen: boolean
  isSubmit: boolean
  params?: object

  setParams: (params: object) => void

  setIsOpen: (isOpen: boolean) => void
  setIsSubmit: (isSubmit: boolean) => void
  openModal: (params?: object) => void

  onRequestClose: () => void

  callback: () => boolean
  setCallback: (fn: () => boolean) => void
}

const useModalStore = create<ModalStore>((set) => ({
  isOpen: false,
  isSubmit: false,
  params: undefined,

  setParams: (params: object) => {
    set({ params })
  },
  setIsOpen: (isOpen: boolean) => {
    set({ isOpen })
  },
  setIsSubmit: (isSubmit: boolean) => {
    set({ isSubmit })
  },
  openModal: (params?: object) => {
    set({ isOpen: true, params })
  },
  onRequestClose: () => {
    set((state) => ({ isOpen: !state.callback() }))
  },

  callback: () => true,
  setCallback: (callback) => {
    set({ callback })
  }
}))

export default useModalStore
